import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { getHebrewYear } from '../../../../../../utils/hebrew-date-utils';
import globalSettingsBranches from '../../../../../../stores/global-settings-branches';
import { toast } from 'react-toastify';

interface CreateProgramDatamodel {
  loading: boolean;
  approve: (startYear: number) => any;
}

export const CreateProgram: React.FC<CreateProgramDatamodel> = ({
  loading,
  approve,
}) => {
  const [workingYear, setWorkingYear] = useState<number | null>(null);

  const availableWorkingYears =
    globalSettingsBranches.workingTimeManagement.availableWorkingYears;

  const years = availableWorkingYears.map((item) => ({
    year: `${getHebrewYear(item)} (${item} - ${item + 1})`,
    code: 'year',
    value: item,
  }));

  const handleApprove = () => {
    if (!workingYear) {
      toast.warn('יש לבחור שנת התחלה לתוכנית');
      return;
    }

    approve(workingYear);
  };

  return (
    <div>
      <label>שנת התחלה</label>

      <Dropdown
        value={workingYear}
        options={years}
        style={{ width: '100%', marginTop: '8px', marginBottom: '16px' }}
        onChange={(e) => setWorkingYear(e.value)}
        optionLabel="year"
        placeholder="בחר שנת התחלה"
        dir="rtl" // Add this line for RTL support
        panelStyle={{ maxWidth: '200px' }}
      />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ height: '30px' }}
          label={'אישור'}
          loading={loading}
          onClick={handleApprove}
        />
      </div>
    </div>
  );
};
